import { Injectable } from '@angular/core';
import { NexusApiService } from '@df/api/nexus/nexus-api.service';
import { Queue } from '@df/util/queue/queue';
import { Nexus } from '@tomandco/nexus-api-types';

@Injectable({
    providedIn: 'root'
})
export class LocalNexusApiService extends NexusApiService {
    private basketQueue = new Queue({ max: 1 });

    constructor() {
        super();

        /**
         * https://tomandco.atlassian.net/browse/LER-4703
         *
         * Queue set for requests not to perform action at the same time
         */
        // qty override to include in queue
        const qty = this.basket.qty;
        this.basket.qty = (data: Nexus.Api.Basket.Qty.Request): Promise<Nexus.Api.Basket.Qty.Response> => {
            return this.basketQueue.add<Nexus.Api.Basket.Qty.Response>(() => qty(data));
        };

        // remove override to include in queue
        const remove = this.basket.remove;
        this.basket.remove = (data: Nexus.Api.Basket.Remove.Request): Promise<Nexus.Api.Basket.Remove.Response> => {
            return this.basketQueue.add<Nexus.Api.Basket.Remove.Response>(() => remove(data));
        };
    }
}
